/* eslint-disable @typescript-eslint/ban-types */
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Button, Typography } from '@mui/material';
import { PALETTE } from '~/assets/styles/base';
import { ANSWER_CONFIG_TYPE, QUESTION_TYPE_ID } from '~/common/constants';

type StyledComponentProps = {
  $background: string;
};
const AnswerComponent = styled.div<StyledComponentProps>`
  background: ${(props) => props.$background};
  width: 716px;
  display: flex;
  flex-direction: row;
  padding: 25px 7px 15px 7px;
  margin-left: 17px;
  height: auto;
`;

const StyledButton = styled(Button)`
  color: ${PALETTE.text.primary};
  font-size: 14px;
  &.MuiButtonBase-root:hover {
    background-color: 'transparent';
  }
`;

const StyledTypography = styled(Typography)`
  color: ${PALETTE.text.main};
  display: flex;
  align-items: center;
`;

type Props = {
  questionType: number;
  answersComponentLength: number;
  handleAddAnswer: Function;
};

const AnswerControl: React.FC<Props> = ({
  questionType,
  answersComponentLength,
  handleAddAnswer,
}: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <AnswerComponent $background="#FFFFFF">
      <StyledTypography data-testid="answer-num" variant="body3">{`${
        answersComponentLength + 1
      }.`}</StyledTypography>

      <StyledButton
        onClick={(event) => {
          event.stopPropagation();
          handleAddAnswer(ANSWER_CONFIG_TYPE.NEW);
        }}
        data-testid="add-new-answer-button"
        variant="text"
        sx={{ marginLeft: '15px' }}
      >
        {t('registration.originalForm.manual.saComponent.addChoice')}
      </StyledButton>

      <StyledTypography data-testid="answer-or-label-first" variant="body3">
        {t('registration.originalForm.manual.saComponent.or')}
      </StyledTypography>

      <StyledButton
        onClick={(event) => {
          event.stopPropagation();
          handleAddAnswer(ANSWER_CONFIG_TYPE.OTHER_REQUIRED);
        }}
        data-testid="add-other-answer-required-button"
        variant="text"
      >
        {t('registration.originalForm.manual.saComponent.addOther')}
      </StyledButton>

      {questionType === QUESTION_TYPE_ID.MULTIPLE_ANSWER && (
        <>
          <StyledTypography data-testid="answer-or-label-second" variant="body3">
            {t('registration.originalForm.manual.saComponent.or')}
          </StyledTypography>

          <StyledButton
            onClick={(event) => {
              event.stopPropagation();
              handleAddAnswer(ANSWER_CONFIG_TYPE.EXCLUSIVE_REQUIRED);
            }}
            data-testid="add-exclusive-answer-required-button"
            variant="text"
          >
            {t('registration.originalForm.manual.saComponent.addNotApplicable')}
          </StyledButton>
        </>
      )}
    </AnswerComponent>
  );
};

export default AnswerControl;
